"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OpaqueToken = (function () {
    function OpaqueToken(_desc) {
        _classCallCheck(this, OpaqueToken);

        this._desc = _desc;
    }

    _createClass(OpaqueToken, [{
        key: "toString",
        value: function toString() {
            return "Token " + this._desc;
        }
    }]);

    return OpaqueToken;
})();

exports.OpaqueToken = OpaqueToken;
//# sourceMappingURL=opaque-token.js.map



//////////////////
// WEBPACK FOOTER
// ./${exlibris_product}/npm_modules/August2022-PROD/prima/node_modules/ng-forward/cjs/classes/opaque-token.js
// module id = 263
// module chunks = 6